import Docs from '../components/Documents';
import PageLayout from '../components/pageLayout';

function DocsPage() {
    return (
        <PageLayout children={<Docs />} />
    );
}

export default DocsPage;
